import { render } from "./color-picker-gradient.vue?vue&type=template&id=0d66245f&scoped=true"
import script from "./color-picker-gradient.vue?vue&type=script&lang=js"
export * from "./color-picker-gradient.vue?vue&type=script&lang=js"

import "./color-picker-gradient.vue?vue&type=style&index=0&id=0d66245f&lang=scss&scoped=true"

import exportComponent from "D:\\work\\npm\\vue3-color-picker-gradient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d66245f"]])

export default __exports__